/**
 * Centralised SEO constants and schema.org (JSON-LD) builders.
 * Consumed by usePageSetup() to inject structured data per route.
 */

export const SITE_ORIGIN = 'https://finhudas.app'
export const SITE_NAME = 'Finhudas'
const LOGO_URL = `${SITE_ORIGIN}/favicon.png`

type JsonLd = Record<string, unknown>

export const organizationSchema = (): JsonLd => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_ORIGIN,
  logo: LOGO_URL,
})

export const websiteSchema = (): JsonLd => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_ORIGIN,
  inLanguage: 'lt-LT',
})

export const softwareApplicationSchema = (): JsonLd => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: SITE_NAME,
  applicationCategory: 'FinanceApplication',
  operatingSystem: 'iOS, Android, Web',
  url: SITE_ORIGIN,
  description:
    'Apskaitos programa Bolt ir Uber pavežėjams: automatinis pajamų importas, mokesčių (GPM, VSD, PSD, PVM) skaičiavimas ir deklaracijų pildymas.',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5',
    bestRating: '5',
    worstRating: '1',
    ratingCount: '5',
  },
})

interface ArticleInput {
  title: string
  description: string
  url: string
  datePublished?: string
  dateModified?: string
  image?: string
}

export const articleSchema = ({
  title,
  description,
  url,
  datePublished,
  dateModified,
  image,
}: ArticleInput): JsonLd => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: title,
  description,
  inLanguage: 'lt-LT',
  mainEntityOfPage: { '@type': 'WebPage', '@id': url },
  author: { '@type': 'Organization', name: SITE_NAME, url: SITE_ORIGIN },
  publisher: {
    '@type': 'Organization',
    name: SITE_NAME,
    logo: { '@type': 'ImageObject', url: LOGO_URL },
  },
  ...(image ? { image } : {}),
  ...(datePublished ? { datePublished, dateModified: dateModified || datePublished } : {}),
})

interface Crumb {
  name: string
  url: string
}

export const breadcrumbSchema = (items: Crumb[]): JsonLd => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
})
